module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero_brodno_kids-c8525a590678601efc5c936873c21519.svg";